import { Button, FormControlLabel, Switch, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Ingredient from "../../components/Ingredient";
import RecipeQuantity from "../../components/RecipeQuantity";
import {
  ADD_EXTRA_INGREDIENT,
  ADD_LIST,
  CLEAR_SHOPPING,
  REMOVE_EXTRA_INGREDIENT,
  TOGGLE_NEED_INGREDIENT,
} from "../../constants/reducerEvents";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";
import { getCombinedList } from "../../utils/shopping.utils";
import CombinedIngredient from "../../components/CombinedIngredient";
export default function Shopping() {
  const dispatch = useDispatch();
  const [name, setName] = useState("");

  const [showCombined, setShowCombined] = useState(false);
  const currentList = useSelector((state) => state.shopping);
  const selectedRecipies = useSelector((state) => state.shopping.selected);
  useEffect(() => {
    setName(currentList.name);
  }, [currentList.id]);
  const [combinedList, setCombinedList] = useState([]);
  useEffect(() => {
    setCombinedList(getCombinedList(currentList));
  }, [currentList]);
  const individualIngredients = useSelector(
    (state) => state.shopping.extraIngredients
  );
  const [ingredientInput, setIngredientInput] = useState("");
  const submitIngredient = () => {
    dispatch({ type: ADD_EXTRA_INGREDIENT, payload: ingredientInput });
    setIngredientInput("");
  };
  const saveList = () => {
    const newList = {
      ...currentList,
      id: currentList.id === null ? uuidv4() : currentList.id,
      date: moment().toISOString(),
      finished: false,
      name: name,
    };
    dispatch({ type: ADD_LIST, payload: newList });
    setName("Grocery List");
  };
  const clearList = () => {
    dispatch({ type: CLEAR_SHOPPING });
  };
  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        height: "100%",
        position: "relative",
      }}
    >
      <div
        style={{
          positon: "absolute",
          right: 0,
        }}
      >
        <Button onClick={clearList}>Clear</Button>
      </div>
      <div style={{ flexGrow: 1 }}>
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          {selectedRecipies.map((r) => (
            <RecipeQuantity recipe={r} />
          ))}
        </div>
        <div
          style={{ textAlign: "center", fontSize: "25px", fontWeight: "500" }}
        >
          Already Have
        </div>
        {showCombined ? (
          <div>
            {combinedList
              .filter((i) => !i.checked.some((t) => !t))
              .map((i) => (
                <CombinedIngredient ingredient={i} />
              ))}
          </div>
        ) : (
          <div>
            {selectedRecipies
              .filter((r) => r.ingredients.some((i) => i))
              .map((recipe) => (
                <div style={{ padding: "10px" }}>
                  <div style={{ fontSize: "18px", fontWeight: "500" }}>
                    {`${recipe.recipe.name} (${
                      Math.round(
                        (100 * recipe.quantity) /
                          parseInt(recipe.recipe.recipeYield)
                      ) / 100
                    }x)`}
                  </div>
                  {recipe.ingredients.map(
                    (hasIng, i) =>
                      hasIng && (
                        <Ingredient
                          name={recipe.recipe.recipeIngredients[i]}
                          checked={hasIng}
                          onClick={() =>
                            dispatch({
                              type: TOGGLE_NEED_INGREDIENT,
                              payload: { url: recipe.recipe.url, index: i },
                            })
                          }
                        />
                      )
                  )}
                </div>
              ))}
          </div>
        )}
      </div>
      <div
        style={{
          width: "800px",
          borderLeft: "solid black 1px",
        }}
      >
        <div
          style={{
            marginLeft: "auto",
            marginRight: "auto",
            width: "fit-content",
            paddingTop: "10px",
          }}
        >
          <input
            style={{
              textAlign: "center",
              fontSize: "25px",
              fontWeight: "500",
            }}
            defaultValue="Grocery List"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <div
          style={{
            marginLeft: "auto",
            marginRight: "auto",
            width: "fit-content",
            paddingTop: "2px",
          }}
        >
          <Button variant="outlined" onClick={saveList}>
            Save
          </Button>
          <FormControlLabel
            sx={{ pl: "10px" }}
            control={
              <Switch
                checked={showCombined}
                onChange={() => setShowCombined((c) => !c)}
              />
            }
            label="Combine Lists"
          />
        </div>

        <div style={{ padding: "10px" }}>
          <div style={{ fontSize: "18px", fontWeight: "500" }}>
            Extra Items:
          </div>
          {individualIngredients.map((ing, i) => (
            <Ingredient
              name={ing}
              checked={false}
              onClick={() => {
                dispatch({ type: REMOVE_EXTRA_INGREDIENT, payload: i });
              }}
            />
          ))}

          <TextField
            variant="outlined"
            value={ingredientInput}
            placeholder="Input Ingredient"
            onKeyDown={(e) => {
              if (e.keyCode === 13) {
                e.preventDefault();
                submitIngredient();
              }
            }}
            onChange={(e) => setIngredientInput(e.target.value)}
          />
        </div>
        {showCombined ? (
          <div>
            {combinedList
              .filter((i) => i.checked.some((t) => !t))
              .map((i) => (
                <CombinedIngredient ingredient={i} />
              ))}
          </div>
        ) : (
          <div>
            {selectedRecipies.map((recipe) => (
              <div style={{ padding: "10px" }}>
                <div style={{ fontSize: "18px", fontWeight: "500" }}>
                  {`${recipe.recipe.name} (${
                    Math.round(
                      (100 * recipe.quantity) /
                        parseInt(recipe.recipe.recipeYield)
                    ) / 100
                  }x)`}
                </div>
                {recipe.ingredients.map(
                  (hasIng, i) =>
                    !hasIng && (
                      <Ingredient
                        name={recipe.recipe.recipeIngredients[i]}
                        multiplier={
                          recipe.quantity / parseInt(recipe.recipe.recipeYield)
                        }
                        calculated={
                          recipe.recipe.parsedIngredients
                            ? recipe.recipe.parsedIngredients[i]
                            : null
                        }
                        checked={false}
                        onClick={() =>
                          dispatch({
                            type: TOGGLE_NEED_INGREDIENT,
                            payload: { url: recipe.recipe.url, index: i },
                          })
                        }
                      />
                    )
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
